import { TABLE_COLUMN_WIDTH } from "components/ModelCompare/constants";
import type { Section } from "../types";
import { highCapacityAggregation } from "./products/highCapacityAggregation";
import { missionCritical } from "./products/missionCritical";
import { professional24 } from "./products/professional24";
import { professional24PoE } from "./products/professional24PoE";
import { professional48 } from "./products/professional48";
import { professional48PoE } from "./products/professional48PoE";
import { professionalHd24 } from "./products/professionalHd24";
import { professionalHd24Poe } from "./products/professionalHd24Poe";
import { professionalMax16 } from "./products/professionalMax16";
import { professionalMax16PoE } from "./products/professionalMax16PoE";
import { professionalMax24 } from "./products/professionalMax24";
import { professionalMax24PoE } from "./products/professionalMax24PoE";
import { professionalMax48 } from "./products/professionalMax48";
import { professionalMax48PoE } from "./products/professionalMax48PoE";
import { professionalXg10PoE } from "./products/professionalXg10PoE";
import { professionalXg24PoE } from "./products/professionalXg24PoE";
import { professionalXg48PoE } from "./products/professionalXg48PoE";
import { proXgAggregation } from "./products/proXgAggregation";
import {
  dimensions,
  downlinkSpeed,
  etherlighting,
  mounting,
  poeAvailability,
  poeOutput,
  portCount,
  proAvSupport,
  uplinkSpeed,
} from "./properties";
import { generalRedundancy } from "./properties/generalRedundancy";

export const SwitchingProfessional: Section = {
  properties: [
    dimensions,
    portCount,
    downlinkSpeed,
    uplinkSpeed,
    poeOutput,
    poeAvailability,
    etherlighting,
    proAvSupport,
    mounting,
    generalRedundancy,
  ],
  products: [
    proXgAggregation,
    // Pro XG SubList
    professionalXg48PoE,
    professionalXg24PoE,
    professionalXg10PoE,
    // Pro HD SubList
    professionalHd24Poe,
    professionalHd24,
    // spencer order request
    highCapacityAggregation,
    // Pro Max SubList
    professionalMax48PoE,
    professionalMax24PoE,
    professionalMax16PoE,
    professionalMax48,
    professionalMax24,
    professionalMax16,
    // Professional SubList
    professional48PoE,
    professional24PoE,
    professional48,
    professional24,
    missionCritical,
  ],
  columnWidth: TABLE_COLUMN_WIDTH,
  showBadges: true,
};
